// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-PY6dq2","pane":"pane-FM1IN8"};